import { jsxs as t, jsx as s } from "react/jsx-runtime";
import e from "./in-page-links.module.less.js";
const m = ({ title: r, links: a }) => /* @__PURE__ */ t("div", { className: e.wrapper, children: [
  /* @__PURE__ */ s("p", { className: `${e.title} body-s bold`, children: r }),
  /* @__PURE__ */ s("ul", { className: e.links, children: a.map((l) => /* @__PURE__ */ s("li", { className: e.listItem, children: /* @__PURE__ */ s("a", { className: e.link, href: l.anchor, children: l.title }) }, l.title)) })
] });
export {
  m as InPageLinks,
  m as default
};
